import { PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS } from 'stash/actions/api';
import { GRAPHQL_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS } from 'stash/actions/apolloGraphql';

const onboarding_answers = (state = {}, action) => {
	switch (action.type) {
		case GRAPHQL_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS: {
			return {
				...state,
				...action.response.questions,
			};
		}

		case PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS: {
			const questions = action.request.body.data.reduce((acc, question) => {
				return {
					...acc,
					[question.questionKey]: {
						answers: question.answerKeys,
					},
				};
			}, {});

			return {
				...state,
				...questions,
			};
		}

		default:
			return state;
	}
};

export default onboarding_answers;
